/**
@license
Copyright (c) 2018 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/

/*
 * Placeholder object class representing items being loaded.
 *
 * @private
 */
export const ComboBoxPlaceholder = class ComboBoxPlaceholder {
  toString() {
    return '';
  }

};